export default __webpack_public_path__ + "img/ic-summary.b77a93d0.svg";